import React, { useState } from "react";
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet-async";
export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_cb11cml", // Your Service ID
        "template_4c67t9u", // Your Template ID
        formData, // Form Data
        "RHROxhmGCDfl1-cCW" // Your Public Key
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setIsSubmitted(true);
          setFormData({ name: "", email: "", message: "" }); // Clear the form fields
        },
        (err) => {
          console.error("FAILED...", err);
          setError(true);
        }
      );
  };

  return (
    <>
    <Helmet>
                <title>Contact Us - Xebrand</title>
                <meta
                  name="Contact Us "
                  content="Ge to know about Xebrand Contact Us  for your digital marketing and web development needs. We are here to help!"
                />
              </Helmet>
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full p-6 bg-white rounded shadow-md">
        <h2 className="text-2xl font-bold mb-4 text-center">Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 font-bold mb-2" htmlFor="name">
              Name
            </label>
            <input
              className="w-full p-2 border rounded"
              type="text"
              id="name"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-gray-700 font-bold mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              className="w-full p-2 border rounded"
              type="email"
              id="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-gray-700 font-bold mb-2"
              htmlFor="message"
            >
              Message
            </label>
            <textarea
              className="w-full p-2 border rounded"
              id="message"
              name="message"
              placeholder="Your Message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <button
            className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
            type="submit"
          >
            Send Message
          </button>
        </form>

        {isSubmitted && (
          <p className="text-green-500 mt-4 text-center">
            Your message has been sent successfully!
          </p>
        )}
        {error && (
          <p className="text-red-500 mt-4 text-center">
            Something went wrong. Please try again.
          </p>
        )}
      </div>
    </div>
    </>
  );
}
